<template>
	<div style="padding:10;background:var(--grey-2);padding:10px;border-radius: 5px;" class="flexcenter">

		<Circle fileName="w3_rocket_white" padding="15%" size="35px" cursor="unset" color="--bg-error" hover=""/>
		<div class="flexcenter" style="flex-direction: column;align-items: start;margin-left:10px;">
			<b style="color:grey;">Leveranstid {{ this.product?.manufactorName }}</b>
			<b style="font-size:80%;">{{ this.product?.details?.deliveryTime }}</b>
		</div>

	</div>
</template>
<script>

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";

export default {
	name: "DeliveryTime",
	components: {},
	mixins: [],
	props: {
		product:Object

	},
	data() {
		return {

		};
	},
	computed: {

		get() {
			//return this.$store.state.productStore.data.productList.filter(product => product !== null);
			//return this.$store.getters[STORE_GETTER.UNREAD_ERROR_MESSAGE]
			return 1

		}

		//baseModel() {
		//	return this.$store.getters[STORE_GETTER.BASE_MODEL]
		//},


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });


	},
	created() {

	}
};
</script>

<style scoped></style>